<template>
  <section class="ecom materials materials--prohibited">
    <h2 class="ecom materials__header">Prohibited Items</h2>
    <p class="ecom materials__text">While you can toss most common items in a roll off dumpster, these materials are not allowed:</p>
    <ul class="ecom materials__list">
      <li><img :src="imgPath">Tires &amp; Railroad Ties</li>
      <li><img :src="imgPath">Industrial Drums &amp; Contaminated Absorbents</li>
      <li><img :src="imgPath">Flammable Waste, Including Fuels, Oils, Batteries, Paints & Lacquers</li>
      <li><img :src="imgPath">Asbestos, Medical Waste &amp; Other Hazardous Materials</li>
      <li><img :src="imgPath">Inks, Resins &amp; Adhesives</li>
      <li><img :src="imgPath">Food Waste</li>
      <li><img :src="imgPath">Refrigerators, Air Conditioners &amp; Water Tanks</li>
    </ul>
  </section>
</template>

<script>
import config from '@/config'

const { cdn } = config
export default {
  data () {
    return {
      imgPath: `${cdn}icons-prohibitied-x.svg`
    }
  }
}
</script>
